export default __webpack_public_path__ + "static/media/fb_share.8ad69350.svg";